import { jsx as _jsx } from "react/jsx-runtime";
// Local copy of the shared DateFilter (same look) for the hour-registration page only.
// Adds an English month picker and an optional status line per month button.
import { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ArrowDown2 } from 'iconsax-react';
import { yellowMain } from '@ui/constants/color';
import dayjs from 'dayjs';
export default function HoursPeriodFilter({ onChange, selectedDate, disabled, getMonthStatus }) {
    const currentYear = dayjs().year();
    const startYear = currentYear - 1;
    const [viewYear, setViewYear] = useState(selectedDate.year());
    const handleDateChange = (newDate) => {
        if (newDate) {
            onChange(newDate.month() + 1, newDate.year());
        }
    };
    return (_jsx("div", { onDragStart: (e) => e.preventDefault(), onDrop: (e) => e.preventDefault(), children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: 'en', children: _jsx(DatePicker, { sx: {
                    maxWidth: '170px',
                    '& .MuiInputBase-root': {
                        border: 'none',
                        color: yellowMain
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                        backgroundColor: 'transparent !important',
                        color: 'rgba(0, 0, 0, 0.38)',
                        WebkitTextFillColor: `${yellowMain} !important`
                    },
                    '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: `${yellowMain} !important`,
                        color: 'rgba(0, 0, 0, 0.38)',
                        backgroundColor: 'transparent !important'
                    }
                }, views: ['month', 'year'], value: selectedDate, minDate: dayjs().year(startYear).startOf('year'), maxDate: dayjs().year(currentYear).endOf('year'), onChange: handleDateChange, onOpen: () => setViewYear(selectedDate.year()), onYearChange: (date) => date && setViewYear(date.year()), disabled: disabled, slots: {
                    openPickerIcon: () => _jsx(ArrowDown2, { size: 20, color: disabled ? 'grey' : yellowMain })
                }, slotProps: {
                    textField: {
                        inputProps: {
                            readOnly: true,
                            onKeyDown: (e) => e.preventDefault()
                        }
                    },
                    ...(getMonthStatus
                        ? {
                            monthButton: (ownerState) => {
                                const status = getMonthStatus(ownerState.value + 1, viewYear);
                                if (!status)
                                    return {};
                                // Keeps the MUI month button (and its styling); only adds a small status line.
                                return {
                                    'aria-label': `${ownerState['aria-label']} · ${status}`,
                                    style: { height: 'auto', minHeight: 36, padding: '3px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.15 },
                                    children: [
                                        _jsx("span", { children: ownerState.children }, 'month'),
                                        _jsx("span", { style: { fontSize: 10, fontWeight: 500, opacity: 0.8 }, children: status }, 'status')
                                    ]
                                };
                            }
                        }
                        : {})
                } }) }) }));
}
